'use strict';

export function localize({ geo1, geo2 }) {
  if(typeof document === "undefined") return;

  const localizedVars = {
    city: '',
    postalCode: ''
  }

  if(typeof geo1 === "object") {
    const _ipLocation = 'ipLocation' in geo1 && typeof geo1.ipLocation === "object" ? geo1.ipLocation : {};
    localizedVars.city = 'city' in _ipLocation ? _ipLocation?.city?.name : localizedVars.city;
    localizedVars.postalCode = 'postalCode' in _ipLocation ? _ipLocation?.postalCode : localizedVars.postalCode;
  }

  if(typeof geo2 === "object") {
    localizedVars.city = localizedVars.city === "" && 'city' in geo2 ? geo2?.city : localizedVars.city;
    localizedVars.postalCode = localizedVars.postalCode === "" && 'postalCode' in geo2 ? geo2?.postalCode : localizedVars.postalCode;
  }

  try {
    let pageVariables = document.querySelectorAll("span.page-variable");
    pageVariables.forEach((pageVariable, index) => {
      let varName = pageVariable.dataset.name?.toString()?.trim();
      if((localizedVars.hasOwnProperty(varName))) {
        pageVariable.firstChild.nodeValue = localizedVars[varName];
      }
    });
  } catch(e) {
    e = null;
  }
}

// <span className="page-variable" data-name="visitor-city">Texas</span>